module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.box), function(item, index) {
    return _c('checkbox', {
      attrs: {
        "true-value": item.id
      },
      on: {
        "on-change": _vm.selectArray
      },
      model: {
        value: (_vm.itemArray[index]),
        callback: function($$v) {
          _vm.$set(_vm.itemArray, index, $$v)
        },
        expression: "itemArray[index]"
      }
    }, [_c('span', [_vm._v(_vm._s(item.title))])])
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d047a58","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CheckBox.vue
// module id = 1885
// module chunks = 8